import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AsignacionesService } from 'src/app/core/services/asignaciones/asignaciones.service';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
import { DataService } from 'src/app/data.service';
import { FiltroAsignaciones } from 'src/app/shared/models/filtrosAsignaciones';
import { AsignarComponent } from '../asignar/asignar.component';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-tabla-asignadas',
  templateUrl: './tabla-asignadas.component.html',
  styleUrls: ['./tabla-asignadas.component.scss']
})
export class TablaAsignadasComponent implements OnInit {
  filtros = new FiltroAsignaciones();
  assigned: any[] = []
  activeFilter: string = '';
  activeEdit: number | null = null;
  secciones: any
  rol: any;
  input: any = {}
  sectionFilters: any[] = []
  userFilters: any[] = []
  codesFilters = []
  namesFilters = []
  orders: any[] = [
    { name: "Más Recientes", value: "-1" },
    { name: "Más Antiguos", value: "1" },
  ];


  ordersValues: any[] = [
    { name: "Fecha y Hora ", value: "When" },
    { name: "OT", value: "OT" },
    { name: "Sección", value: "Seccion" },
    { name: "Código EMyR", value: "CodigoEstacion" },
    { name: "Frecuencia ", value: "Frecuencia" },
  ];

  constructor(public snackBar: MatSnackBar,
    private asignacionService: AsignacionesService,
    public dialog: MatDialog,
    private usuarioService: UsuarioService
  ) {
    this.secciones = this.usuarioService.getSections();
    this.rol = this.usuarioService.getRoles()


    if (!this.secciones.includes('*')) {
      if (this.rol.includes("EJECUTOR")) {
        this.filtros.username = this.usuarioService.getUsername().toLowerCase();
      }
      this.input.sectionsCods = this.secciones;
      this.filtros.sectionsCods = this.input.sectionsCods
    }
  }

  ngOnInit(): void {
    this.changePageTable2(1);

  }
  pagesTotalTable2 = 1;
  changePageTable2(page: number) {
    this.filtros.pageNumber = page;
    this.cargarLista();
  }
  puedeCambiar(item) {
    if (this.rol && item.Who[0]) {
      if (this.rol.includes('EJECUTOR') && item.Who[0].username.toLocaleUpperCase() == this.usuarioService.getUsername().toLocaleUpperCase()) {
        return true;
      }
      if (this.rol.includes('JEFE DE SECCIÓN') || this.rol.includes("ANALISTA DE MANTENIMIENTO")) {
        if (this.secciones.includes(item.Status.CodigoSeccion?.Observed) || this.secciones[0] == '*') {
          return true;
        }
      } else {
        return false;
      }
    }
    return false;
  }
  cargarLista() {
    this.filtros.state = ['assigned', 'downloaded'];

    localStorage.setItem('filtroAsignadas', JSON.stringify(this.filtros))
    this.asignacionService.filtrar(this.filtros).subscribe(res => {
      this.assigned = res.data.map(item => {
        item.When = new Date(item.When)
        return item;
      });
      this.filtros.totalItems = res.count;
      this.filtros.pageTotal = Math.ceil(res.count / this.filtros.NPerPage);
      $('#spinner-load').css("display", "none");
    })

  }
  filterText(tipo, event) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.filtros[tipo] = inputValue;
  }
  filterDate(tipo, event) {
    const inputValue = (event.target as HTMLInputElement).value;
    const inputDate = new Date(inputValue);
    const inputDateInMilliseconds = inputDate.getTime();
    this.filtros[tipo] = inputDateInMilliseconds;
  }
  filterSelect(tipo, event) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.filtros[tipo] = inputValue;
  }
  asignar(id) {
    const dialogRef = this.dialog.open(AsignarComponent, { panelClass: 'custom-dialog-container', data: { itemsSelecteds: id } });
    dialogRef.afterClosed().subscribe(() => {
      //this.tablaNoAsignadasComponent.cargarLista();
    });
  }

  desasignar(id) {

    this.asignacionService.desasignar(id).subscribe(
      res => {
        this.snackBar.open('Desasignado correctamente', 'x', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['green-snackbar'],
        });
        this.cargarLista()
      },
      (err) => {
        let errorMessage = 'No se pudo desasingar : ' + err.error.message;

        this.snackBar.open(errorMessage, 'x', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['red-snackbar'],
        });
      }
    );
  }

  toggleEdit(index: number) {
    this.activeEdit = this.activeEdit === index ? null : index;
  }
  toggleFilter(filterName: string) {
    this.activeFilter = this.activeFilter === filterName ? '' : filterName;
  }
  limpiar(tipo) {
    if (tipo == "date") {
      this.filtros['startDate'] = null;
      this.filtros['endDate'] = null;
    } else {
      this.filtros[tipo] = null;
      this.input[tipo] = null;
    }
    this.cargarLista();
  }
  addFilter(tipo) {
    if (this.filtros[tipo]) {
      this.filtros[tipo].push(this.input[tipo])
    } else {
      this.filtros[tipo] = [this.input[tipo]]
    }
    this.input[tipo] = '';
    this.cargarLista();
  }
  addUniqueFilter(tipo) {
    this.filtros[tipo] = this.input[tipo]
    this.cargarLista();
  }
  removeFilter(tipo, value) {
    this.filtros[tipo] = this.filtros[tipo].filter(d => d != value);
    this.cargarLista();

  }


  changeOrder(label, value) {
    this.filtros.orderBy[label].value = value;
    this.cargarLista();
  }
  applyOrder(label) {
    this.filtros.orderBy[label].apply = !this.filtros.orderBy[label].apply;
    if (this.filtros.orderBy[label].apply) {
      this.filtros.orderBy.cant++;
      this.filtros.orderBy[label].value = '-1';
      this.filtros.orderBy[label].order = this.filtros.orderBy.cant;
    } else {
      this.filtros.orderBy[label].value = null;
      this.filtros.orderBy[label].order = 0;
    }
    this.cargarLista();
  }
}
